import React from 'react'
import { FlagsIconSeeker, AutocompleteAjaxSeeker } from '@ui-seeker/core'
import { translateCountryName } from '@ui-seeker/utils'
import { Box, Typography } from '@mui/material'
import { useComputed } from '@preact/signals-react'

import { BACKEND_APIS } from '@constants'
import { useAppFormHandler } from '@hooks'
import { formData } from '@signals'


export default function CountrySelector() {

	const { idCountries, onIdCountriesChange } = useAppFormHandler('idCountries')
	const mustHide = useComputed(() => formData.value?.isCheckedOffice)


	if (mustHide.value) return null

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		multiple
		label="Country"
		formatOptionLabel={({ value }) => <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: .5 }}>
			<FlagsIconSeeker countryName={value}/>
			<Typography>{translateCountryName(value)}</Typography>
		</Box>}
		placeholder="All Countries"
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/office-countries`}
		value={idCountries || ''}
		onChange={e => onIdCountriesChange(e.target.value)}
	/>
}